export const SET_BACK_FORWARD_DIRECTORY = 'SET_BACK_FORWARD_DIRECTORY';